import { type CompraAgilDetalleResponse } from './api.schema';
import { type CompraAgilDetalleUi } from './ui.schema';

export { 
  CompraAgilDetalleResponseSchema,
  type CompraAgilDetalleResponse,
  type CompraAgilDetalleData,
  type JsonMetadataCompraAgilDetalle,
  type ArchivoCompraAgilDetalle,
  type PreguntaRespuestaCompraAgilDetalle
} from './api.schema';

export { 
  CompraAgilDetalleUiSchema,
  type CompraAgilDetalleUi 
} from './ui.schema';

export const transformCompraAgilDetalleApiToUi = (data: CompraAgilDetalleResponse): CompraAgilDetalleUi => {
  const jsonMetadata = data.data.json_metadata;
  
  let monto_estimado = null;
  let moneda = 'CLP';
  let plazo_entrega = null;
  
  if (jsonMetadata) {
    if ('detalleSolicitud' in jsonMetadata) {
      const metadata = jsonMetadata as any;
      const detalleSolicitud = metadata.detalleSolicitud;
      monto_estimado = detalleSolicitud?.montoMoneda || null;
      moneda = detalleSolicitud?.moneda || 'CLP';
      plazo_entrega = detalleSolicitud?.plazoEntrega || null;
    }
  }
  
  return {
    id: data.data.id,
    nombre: data.data.nombre,
    resumen: data.data.resumen,
    resumen_llm: data.data.resumen_llm,
    codigo_externo: data.data.codigo_externo,
    
    codigo_estado: data.data.codigo_estado,
    estado_licitacion: data.data.estado_compra_agil,
    fecha_creacion: data.data.fecha_creacion,
    fecha_cierre: data.data.fecha_cierre,
    puntaje: data.data.puntaje,
    archivos: data.archivos,
    preguntas_y_respuestas: data.preguntas_y_respuestas_compra_agil,
    estado_notificacion: data.data.estado_notificacion,
    fecha_actualizacion: data.data.fecha_actualizacion,
    monto_estimado,
    moneda,
    plazo_entrega,
    resumen_procesado_filtro_palabras: data.data.resumen_procesado_filtro_palabras,
    archivos_procesados: data.data.archivos_procesados,
    resumen_procesado_filtro_llm: data.data.resumen_procesado_filtro_llm,
    json_metadata: jsonMetadata,
    postulado: data.data.postulado,
    adjudicado: data.data.adjudicado,
    fecha_postulacion: data.data.fecha_postulacion,
    fecha_adjudicacion: data.data.fecha_adjudicacion,
    resumen_general: data.data.resumen_general,
    resumen_archivos_llm: data.data.resumen_archivos_llm
  };
}; 